module.exports = "<div class=\"class-joined-success\">\n  <p>\n    Welcome {{ username }} ! Are you ready for the next fitness revolution experience ? Please grab the tracker <span class=\"pair-id\">pair number {{ pairId }}</span> and get ready for your class: '{{className}}'!\n   </p>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/class-joined-success/class-joined-success.component.html
// module id = ./src/app/components/class-joined-success/class-joined-success.component.html
// module chunks = main